import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="28" cy="28" r="28" fill="#D8D8D8" fillOpacity="0.2" />
      <circle cx="28" cy="28" r="27.5" stroke="#D8D8D8" strokeOpacity="0.2" />
      <mask id="path-3-inside-1" fill="white">
        <rect
          width="23.9997"
          height="24.9997"
          rx="1"
          transform="matrix(-1 0 0 1 44.0007 19)"
        />
      </mask>
      <rect
        width="23.9997"
        height="24.9997"
        rx="1"
        transform="matrix(-1 0 0 1 44.0007 19)"
        stroke="#DF692B"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-3-inside-1)"
      />
      <path
        d="M16.4003 37.7497C15.0749 37.7497 14.0004 36.6304 14.0004 35.2497V16.5C14.0004 15.1193 15.0749 14 16.4003 14H33.2001C34.5256 14 35.6001 15.1193 35.6001 16.5"
        stroke="#DF692B"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Icon;
